import React from 'react';
import './Button.css';
import { useNavigate } from 'react-router-dom';

const AnalyticButton = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/analytics');
    };

    return (
        <button className="analytic-button" onClick={handleClick}>
            Analytics
        </button>
    );
}
export default AnalyticButton;